import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'

const SidebarMenuMainMitraLembaga = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/apps/mitra-lembaga-dashboard/dashboard'
        title='Dashboard'
        hasBullet={true}
      />
      <SidebarMenuItemWithSub
        to='/apps/donation'
        title={`${intl.formatMessage({id: 'APPS.TRANSACTION'})}`}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com017.svg'
      >
        <SidebarMenuItem
          to='/apps/crm/donatur-management/donatur'
          title={`${intl.formatMessage({id: 'APPS.CUSTOMER'})} Management`}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/apps/program/donation-management/donation'
          title={`${intl.formatMessage({id: 'APPS.TRANSACTION'})} Management`}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/apps/program'
        title='Program'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com018.svg'
      >
        <SidebarMenuItem
          to='/apps/program/program-mitra/programs'
          title='Campaign Management'
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/apps/ffiliator-management'
        title='Affiliate'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com019.svg'
      >
        <SidebarMenuItem
          to='/apps/affiliator-partner-management/affiliator-partner'
          title='Affiliator Management'
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
    </>
  )
}

export default SidebarMenuMainMitraLembaga
